module.exports = __webpack_public_path__ + "static/media/자기주식.81a5a8cc.png";